import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import { authApi } from 'api';
import { SendResetPasswordPayload } from 'types/payloads/SendResetPasswordPayload';
import TextField from 'components/_common/forms/TextField';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/_new/Button';

const PasswordReset: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const { control, handleSubmit, setError } = useForm<SendResetPasswordPayload>({
		defaultValues: {
			email: '',
		},
	});

	const {
		mutate,
		isSuccess,
		isLoading: isSubmitting,
	} = useMutation((data: SendResetPasswordPayload) => authApi.sendResetPassword(data), {
		onError: ({ response }) => {
			setError('email', { type: 'custom', message: response.data.message });
		},
	});

	if (isSuccess) {
		return (
			<>
				<div>{t('auth.resetPasswordEmail')}</div>
				<div>{t('auth.resetPasswordCloseTooltip')}</div>
			</>
		);
	}

	return (
		<>
			<Helmet title={t('auth.resetPasswordTitle')} />
			<form onSubmit={handleSubmit((data) => mutate(data))} className="flex flex-column row-gap-4">
				<span className="text-sm">{t('auth.resetPasswordTooltip')}</span>

				<TextField name="email" placeholder={t('auth.inputs.email')} control={control} required />

				<Button submit variant="primary" label={t('auth.buttons.sendLink')} loading={isSubmitting} block />

				<div className="text-sm text-center underline">
					<Button label={t('auth.backToLogin')} variant="primary-text" onClick={() => navigate('/login')} />
				</div>
			</form>
		</>
	);
};

export default PasswordReset;
